// src/api/userService.js
import apiClient from './client';


export const GroupsService = {
    async getGroups(query: any) {

        if (query.numbers) {
            query = { ...query, numbers: "[" + query.numbers.join(",") + "]" }
        }

        const response = await apiClient.get('/api/group/', { params: query });
        return response;
    },
    async getGroupInfo(id: any) {
        const response = await apiClient.get(`/api/group/${id}`);
        return response;
    }
}
